import { Typography } from '@mui/material';

interface IProps {
	error: string;
}

export const ErrorText = ({ error }: IProps) => {
	return (
		<Typography variant="body1" sx={{ color: 'red', textAlign: 'center' }}>
			{error}
		</Typography>
	);
};
